import React from 'react';
import { useTranslation } from "react-i18next";
import SearchBar from './SearchBar';

/**
 * TableHeader Component
 * Grey header section with title, filter, search, and items per page selector
 */
export default function TableHeader({
  title,
  subtitle,
  searchValue,
  onSearchChange,
  searchPlaceholder,
  showSearch = true,
  itemsPerPage,
  onItemsPerPageChange,
  itemsPerPageOptions = [5, 10, 25, 50],
  itemsPerPagePlacement = "bottom", // "bottom" | "top"
  // Filter props (optional)
  filterValue,
  onFilterChange,
  filterOptions = [],
  filterLabel,
  showFilter = false,
  loading = false, // NEW: loading state prop
}) {
  const { t } = useTranslation();
  const showTopItemsPerPage = itemsPerPagePlacement === "top";
  const showBottomItemsPerPage = !showTopItemsPerPage;
  const showTopRightCluster = showFilter || showTopItemsPerPage;
  const showBottomRow = showSearch || showBottomItemsPerPage;

  return (
    <div className={`admin-users-section-header ${loading ? 'loading-state' : ''}`}>
      {/* Row 1: Context (title + count + status) */}
      <div className="admin-header-row admin-header-row--top">
        <div className="admin-header-left-cluster">
          <h3 className="admin-subsection-title">
            {title}
            {subtitle && (
              <span className={`admin-subtitle ${loading ? 'loading' : ''}`}>
                {subtitle}
              </span>
            )}
          </h3>
        </div>

        {showTopRightCluster && (
          <div className="admin-header-top-right admin-header-top-right-cluster">
            {showFilter && (
              <div className="admin-table-filter">
                <label>{filterLabel || t("admin.common.filter")}:</label>
                <select
                  value={filterValue}
                  onChange={(e) => onFilterChange(e.target.value)}
                  className="admin-filter-select-inline"
                  disabled={loading}
                >
                  {filterOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {showTopItemsPerPage && (
              <div className="admin-items-per-page">
                <label>{t("admin.common.itemsPerPage")}</label>
                <select
                  value={itemsPerPage}
                  onChange={(e) => onItemsPerPageChange(e.target.value)}
                  className="admin-items-per-page-select"
                  disabled={loading}
                >
                  {itemsPerPageOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Row 2: Controls (search on left + items per page on right) */}
      {showBottomRow && (
        <div className="admin-header-row admin-header-row--bottom">
          <div className="admin-header-bottom-left">
            {showSearch && (
              <SearchBar
                value={searchValue}
                onChange={onSearchChange}
                placeholder={searchPlaceholder}
                className="admin-users-search admin-users-search--header"
                disabled={loading}
              />
            )}
          </div>

          <div className="admin-header-right-cluster">
            {showBottomItemsPerPage && (
              <div className="admin-items-per-page">
                <label>{t("admin.common.itemsPerPage")}</label>
                <select
                  value={itemsPerPage}
                  onChange={(e) => onItemsPerPageChange(e.target.value)}
                  className="admin-items-per-page-select"
                  disabled={loading}
                >
                  {itemsPerPageOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
